import Marionette from "backbone.marionette";
import Photo from "../../photo/index";
import Title from "./title/index";
import templates from "../../../../../utils/templates";

const DEFAULTS = {
  className: "flex",
  template: templates.find("masthead", "avatar_dropdown_header"),
};

class Header extends Marionette.LayoutView {
  constructor(options = {}) {
    _.defaults(options, DEFAULTS);
    super(options);
  }

  regions() {
    return {
      photo: ".user-dropdown-avatar",
      title: ".user-dropdown-title",
    };
  }

  initialize() {
    this.user = this.options.user;
  }

  onBeforeShow() {
    this.photo.show(
      new Photo({
        size: "large",
        url: this.user.getPhotoURL(),
      })
    );

    this.title.show(
      new Title({
        model: this.user,
      })
    );
  }
}

export { Header as default };
